export default {
    "open_equity": "Ξεκινώντας τα ίδια κεφάλαια",
    "bonus": "Μπόνους",
    "closed_positions": "Κλειστές θέσεις",
    "finance": "Οικονομικά",
    "watchlist": "Λίστα παρακολούθησης",
    "calendar": "Ημερολόγιο",
    "symbol_information": "Πληροφορίες για το σύμβολο",
    "contact_size": "Μέγεθος επαφής",
    "min_tick_size": "Ελάχιστο μέγεθος tick",
    "min_lot": "Ελάχιστη παρτίδα",
    "max_lot": "Μέγιστη παρτίδα",
    "pip_size": "Μέγεθος Pip",
    "stop_limit_levels": "Επίπεδα Stop & Limit",
    "base_currency": "Απόσπασμα Νόμισμα",
    "swap_type": "Τύπος ανταλλαγής",
    "digits": "Ψηφίδες",
    "trade_id": "Εμπορική ταυτότητα",
    "sell_buy": "Πώληση/Αγορά",
    "instrument": "Όργανο",
    "open_current_price": "Ανοιχτή/Τρέχουσα τιμή",
    "s_slash_l": "S/L",
    "profit_slash_loss": "Κέρδη/Ζημίες",
    'net_pl':'Καθ. P/L',
    "comment": "Σχόλιο",
    "action": "Δράση",
    "proximity": "Εγγύτητα",
    "buy_stop": "Αγοράστε Stop",
    "buy_limit": "Όριο αγοράς",
    "stop_loss": "Διακοπή απώλειας",
    "rate": "Βαθμολογήστε",
    "take_profit": "Πάρτε κέρδος",
    "price": "Τιμή",
    "maximum_20_characters": "Μέγιστο 20 χαρακτήρες",
    "btn_place_buy_order": "Τοποθετήστε την παραγγελία αγοράς",
    "btn_place_sell_order": "Τοποθετήστε παραγγελία πώλησης",
    "change": "Αλλαγή",
    "descrption": "Περιγραφή",
    "asset_class": "Κατηγορία περιουσιακών στοιχείων",
    "subclass": "Υποκατηγορία",
    "major": "Σημαντικό",
    "size_of_1_pip": "Μέγεθος 1 pip",
    "Min_position_size": "Min. Θέση Μέγεθος",
    "Max_position_size": "Max. Θέση Μέγεθος",
    "leverage": "Μόχλευση",
    "daily_swap_points": "Ημερήσια σημεία ανταλλαγής",
    "long": "Μακρύ",
    "short": "σύντομο",
    "market_hours_local_time": "Ώρες αγοράς (τοπική ώρα)",
    "main_trading": "Κύρια/Διαπραγμάτευση",
    "copy_trade": "Αντιγραφή εμπορίου",
    "view_modes": "Προβολή τρόπων λειτουργίας",
    "reports": "Αναφορές",
    "pivot_table": "Πίνακας Pivot",
    "pp": "PP",
    "s1": "S1",
    "s2": "S2",
    "s3": "S3",
    "r1": "R1",
    "r2": "R2",
    "r3": "R3",
    "list_property": "Ακίνητα λίστας",
    "overview": "Επισκόπηση",
    "day_low": "Ημέρα Χαμηλή",
    "prev_close": "Προηγούμενο Κλείσιμο",
    "day_high": "Μέρα Υψηλή",
    "52_week_low": "Χαμηλό 52 εβδομάδων",
    "1_day_range": "Εύρος 1 ημέρας",
    "52_day_range": "Εύρος 52 ημερών",
    "daily": "Καθημερινά",
    "weekly": "Εβδομαδιαία",
    "monthly": "Μηνιαία",
    "moving_averages": "Κινητοί μέσοι όροι",
    "technical_indicators": "Τεχνικοί δείκτες",
    "charts": "Διαγράμματα",
    "trade_log": "Ημερολόγιο εμπορίου",
    "create_new_watchlist": "Δημιουργία νέας λίστας παρακολούθησης",
    "net_profit": "Καθαρά κέρδη",
    "maximum_equity_drawdown": "Μέγιστη ανάληψη ιδίων κεφαλαίων",
    "profit_percentage": "Ποσοστό κέρδους",
    "opening_balance": "Υπόλοιπο εκκίνησης",
    "current_balance": "Τρέχον υπόλοιπο",
    "deposit": "Κατάθεση",
    "withdrawal": "Απόσυρση",
    "economic_calendar": "Οικονομικό ημερολόγιο",
    "dashboard": "Ταμπλό",
    "markets": "Αγορές",
    "portfolio": "Χαρτοφυλάκιο",
    "buzz": "Buzz",
    "view_profile": "Προφίλ",
    "equity": "Μετοχικό κεφάλαιο",
    "realized_profit": "Πραγματοποιημένο κέρδος",
    "unrealized_profit": "Μη πραγματοποιηθέν κέρδος",
    "balance": "Υπόλοιπο",
    "used_margin": "Χρησιμοποιημένο περιθώριο",
    "free_margin": "Ελεύθερο περιθώριο κέρδους",
    "profile": "Προφίλ",
    "settings": "Ρυθμίσεις",
    "theme": "Θέμα",
    "logout": "Αποσύνδεση",
    "trading_account": "Λογαριασμός συναλλαγών",
    "quick_links": "Γρήγοροι σύνδεσμοι",
    "back": "Πίσω",
    "previous": "Προηγούμενο",
    "forecast": "Πρόβλεψη",
    "actual": "Πραγματικό",
    "data": "Ημερομηνία",
    "margin_level": "Επίπεδο περιθωρίου",
    "news": "Νέα",
    "unrealised_pl": "ΜΗ ΠΡΑΓΜΑΤΟΠΟΙΗΘΈΝΤΑ ΚΑΘΑΡΆ P/L",
    "unrealised_gross_pl": "ΜΗ ΠΡΑΓΜΑΤΟΠΟΙΗΘΈΝΤΑ ΑΚΑΘΆΡΙΣΤΑ P/L",
    "quantity": "Ποσότητα",
    "trailing_sl": "Πίσω SL",
    "sell": "Πουλήστε",
    "buy": "Αγοράστε",
    "open_positions": "Ανοικτές θέσεις",
    "close_all_profitable": "Κλείστε όλα τα κερδοφόρα",
    "close_all_losing": "Κλείστε όλα τα Losing",
    "close_all_buy": "Κλείστε όλα Αγοράστε",
    "close_all_sell": "Κλείστε όλα Πώληση",
    "no": "Όχι",
    "yes": "Ναι",
    "are_you_sure": "Είσαι σίγουρος ότι θέλεις να",
    "current_market_rates": "στις τρέχουσες τιμές της αγοράς;",
    "close_all": "Κλείστε όλα",
    "watchlists": "Λίστες παρακολούθησης",
    "default": "Προεπιλογή",
    "add_new_watchlist": "Προσθήκη νέας λίστας παρακολούθησης",
    "delete_watchlist?": "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή τη λίστα παρακολούθησης;",
    "cancel": "Ακύρωση",
    "delete": "Διαγραφή",
    "delete_alert": "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την ειδοποίηση;",
    "condition": "Κατάσταση",
    "triggered": "Προκαθορισμένο",
    "active": "Ενεργό",
    "alert": "Ειδοποίηση",
    "alerts": "Ειδοποιήσεις",
    "going_below": "Πηγαίνοντας παρακάτω",
    "going_above": "Πηγαίνοντας πάνω από τα όρια",
    "bid_price": "Τιμή προσφοράς",
    "ask_price": "Ρωτήστε τιμή",
    "symbol": "Σύμβολο",
    "edit_alert": "Επεξεργασία ειδοποίησης",
    "create_alert_on": "Δημιουργία ειδοποίησης στο",
    "info": "Πληροφορίες",
    "daily_range": "Ημερήσιο εύρος",
    "spread": "Διαδώστε",
    "contract_size": "Μέγεθος σύμβασης",
    "min_trade_size": "Ελάχιστο μέγεθος συναλλαγών",
    "max_trade_size": "Μέγιστο μέγεθος συναλλαγών",
    "swap_long": "Ανταλλαγή Long",
    "swap_short": "Ανταλλαγή Short",
    "create_alert": "Δημιουργία ειδοποίησης",
    "remove_watchlist": "Αφαίρεση από λίστα παρακολούθησης",
    "trading_view_chart": "Διάγραμμα προβολής συναλλαγών",
    "chart": "Διάγραμμα",
    "add": "Προσθέστε",
    "add_instruments_watchlist": "Προσθέστε όργανα στη λίστα παρακολούθησής σας",
    "h": "H",
    "l": "L",
    "cryptos": "Κρυπτογραφίες",
    "indices": "Δείκτες",
    "forex": "Forex",
    "fx": "FX",
    "stocks": "Μετοχές",
    "comm": "Comm",
    "commodities": "Εμπορεύματα",
    "low": "Χαμηλή",
    "high": "Υψηλή",
    "change_percentage": "Αλλαγή %",
    "bid": "Προσφορά",
    "ask": "Ρωτήστε",
    "order": "Παραγγελία",
    "commission": "Επιτροπή",
    "swap": "Ανταλλαγή",
    "open_date": "Ανοιχτή ημερομηνία",
    "lots": "Οικόπεδα",
    "b_slash_s": "B/S",
    "open_price": "Ανοιχτή τιμή",
    "order_price": "Τιμή παραγγελίας",
    "current_price": "Τρέχουσα τιμή",
    "comments": "Σχόλια",
    "modify": "Τροποποίηση",
    "close": "Κλείστε το",
    "ok": "Εντάξει",
    "trailing_stop": " Σταμάτημα παρακολούθησης",
    "trailing_stop_loss": "Παρακολούθηση Stop Loss",
    "quntity": "Quntity",
    "price_level": "Επίπεδο τιμών",
    "type": "Τύπος",
    "trades": "Επαγγέλματα",
    "order_id": "Αναγνωριστικό παραγγελίας",
    "modify_order": "Τροποποίηση παραγγελίας",
    "revert": "Επιστροφή",
    "id": "ID",
    "sl": "SL",
    "tp": "TP",
    "close_order": "Κλείσιμο παραγγελίας",
    "trail_s_slash_l": "Μονοπάτι S/L",
    "pnl_s": "Pnl",
    "direction": "Κατεύθυνση",
    "modify_position": "Τροποποίηση θέσης",
    "close_price": "Κλείσιμο Τιμή",
    "close_date": "Ημερομηνία κλεισίματος",
    "total_p_slash_l": "Σύνολο P/L",
    "place_new_order": "Τοποθετήστε νέα παραγγελία",
    "close_time": "Χρόνος κλεισίματος",
    "open_time": "Ανοιχτή ώρα",
    "p_slash_l": "P/L",
    "reason": "Λόγος",
    "qty": "Ποσότητα",
    "pending_orders": "Εκκρεμείς παραγγελίες",
    "order_type": "Τύπος παραγγελίας",
    "close_all_orders": "Είστε σίγουροι ότι θέλετε να κλείσετε όλες τις ανοιχτές παραγγελίες;",
    "place_order": "Τοποθετήστε την παραγγελία",
    "advanced_options": "Προηγμένες επιλογές",
    "available_margin": "Διαθέσιμο περιθώριο κέρδους",
    "trade": "Εμπόριο",
    "positions": "Θέσεις",
    "orders": "Παραγγελίες",
    "history": "Ιστορία",
    "summary": "Περίληψη",
    "summary_from": "Περίληψη Από:",
    "performance": "Επιδόσεις",
    "profitability": "Αποδοτικότητα",
    "password_validation": "Ο κωδικός πρόσβασης πρέπει να αποτελείται από τουλάχιστον 8 χαρακτήρες, έναν ειδικό χαρακτήρα, ένα γράμμα και ένα ψηφίο.",
    "note": "Σημείωση",
    "change_password": "Αλλαγή κωδικού πρόσβασης",
    "submit": "Υποβολή",
    "select_server_type": "Επιλέξτε Τύπος διακομιστή",
    "create_demo_account": "Δημιουργία λογαριασμού επίδειξης",
    "create_new_account": "Δημιουργία νέου λογαριασμού",
    "account_id": "Αναγνωριστικό λογαριασμού",
    "name": "Όνομα",
    "currency": "Νόμισμα",
    "security": "Ασφάλεια",
    "amount": "Ποσό",
    "select_leverage": "Επιλέξτε μόχλευση",
    "select_currency": "Επιλέξτε νόμισμα",
    "save_settings": "Αποθήκευση ρυθμίσεων",
    "large": "Μεγάλο",
    "small": "Μικρό",
    "font_size": "Μέγεθος γραμματοσειράς",
    "units": "Μονάδες",
    "select_show": "Επιλέξτε Show",
    "order_position_size": "Παραγγελία / Θέση Μέγεθος Σε",
    "custom": "Προσαρμοσμένο",
    "month": "Μήνας",
    "days": "Ημέρες",
    "day": "Ημέρα",
    "select": "Επιλέξτε",
    "history_range": "Εύρος ιστορίας",
    "default_lot_size": "Προεπιλεγμένο μέγεθος οικοπέδου",
    "local_time": "Τοπική ώρα",
    "server": "Διακομιστής",
    "timezone": "Χρονοζώνη",
    "enable": "Ενεργοποίηση",
    "modify_trade": "Τροποποίηση εμπορίου",
    "open": "Ανοίξτε το",
    "enter_quantity": "Εισάγετε την ποσότητα",
    "tooltip": "Tooltip",
    "field": "Πεδίο",
    "value": "Αξία",
    "date_time": "Ημερομηνία/Ώρα",
    "market": "Αγορά",
    "all": "Όλα",
    "verify": "Επαλήθευση",
    "volume": "Τόμος",
    "lot": "παρτίδα",
    "quantity_required": " Απαιτείται ποσότητα.",
    "stop_loss_required": " Απαιτείται stop loss.",
    "distance_points": "Απόσταση από την τρέχουσα τιμή",
    "points": "Σημεία",
    "back_to_login": "Πίσω στο Login",
    "forgot_password": "Ξεχάσατε τον κωδικό πρόσβασης;",
    "enter_username": "Εισάγετε το όνομα χρήστη",
    "login": "Σύνδεση",
    "remember_me": "Να με θυμάσαι",
    "login_another_account": "Σύνδεση με άλλο λογαριασμό",
    "2fa_verification": "Επαλήθευση 2FA",
    "my_profile": "Το προφίλ μου",
    "user_name": "Όνομα χρήστη",
    "email": "Ηλεκτρονικό ταχυδρομείο",
    "already_have_account": " Έχετε ήδη λογαριασμό;",
    "register": "Εγγραφή",
    "last_name": "Επώνυμο",
    "first_name": "Όνομα",
    "password": "Κωδικός πρόσβασης",
    "disable_two_factor_auth": "Απενεργοποίηση του ελέγχου ταυτότητας δύο παραγόντων",
    "enter_6_digit_code": "Εισάγετε τον 6ψήφιο κωδικό επαλήθευσης που δημιουργήθηκε.",
    "enable_two_factor_authentication": "Ενεργοποίηση ελέγχου ταυτότητας δύο παραγόντων",
    "please_click_2fa_enable": "Κάντε κλικ στην επιλογή 2FA που θέλετε να ενεργοποιήσετε.",
    "download_authenticator_app": "Κατεβάστε μια εφαρμογή Αυθεντικοποιητή",
    "download_install_google_authenticator": "Κατεβάστε και εγκαταστήστε το Authy ή το Google Authenticator στο τηλέφωνο ή το tablet σας.",
    "scan_code": "Σαρώστε τον κωδικό QR",
    "open_authentication_app_camera": "Ανοίξτε την εφαρμογή ελέγχου ταυτότητας και σαρώστε την εικόνα στα αριστερά, χρησιμοποιώντας την κάμερα του τηλεφώνου σας.",
    "login_code": "Συνδεθείτε με τον κωδικό σας",
    "two_factor_authentication": "Αυθεντικοποίηση δύο παραγόντων",
    "2fa_already_enabled": "2FA ήδη ενεργοποιημένη Κάντε κλικ στην επιλογή 2FA που θέλετε να απενεργοποιήσετε.",
    "usd": "USD",
    "eur": "EUR",
    "gbp": "GBP",
    "aud": "AUD",
    "enter_6_digit_code_placeholder": "Εισάγετε 6ψήφιο κωδικό",
    "enter_google_verification_code": "Εισάγετε τον κωδικό επαλήθευσης Google",
    "trading_id_placeholder": "Εισάγετε το αναγνωριστικό συναλλαγών σας",
    "password_placeholder": "Εισάγετε τον κωδικό πρόσβασής σας",
    "email_placeholder": "Εισάγετε το email σας",
    "enter_old_password": "Εισάγετε τον τρέχοντα κωδικό πρόσβασης",
    "enter_new_password": "Εισάγετε νέο κωδικό πρόσβασης",
    "enter_new_password_again": "Πληκτρολογήστε ξανά τον νέο κωδικό πρόσβασης",
    "alpha_numeric_dashes_underscores_spaces": "το πεδίο μπορεί να περιέχει μόνο αλφαριθμητικούς χαρακτήρες, καθώς και παύλες, υπογράμμιση και κενά.",
    "is_required": "απαιτείται",
    "field_must_be": " πεδίο πρέπει να είναι",
    "or_more": "είναι ή περισσότερο.",
    "or_less": "είναι ή λιγότερο.",
    "must_be_greater_then": "πρέπει να είναι Μεγαλύτερο τότε.",
    "must_be_less_then": "πρέπει να είναι μικρότερη από",
    "not_valid": "δεν ισχύει",
    "buy_stop_loss_error_message": "Το Stop Loss πρέπει να είναι μικρότερο από την τιμή αγοράς",
    "trailing_stop_required": "Απαιτείται Trailing Stop.",
    "trailing_stop_greater_zero": "Το Trailing Stop πρέπει να είναι μεγαλύτερο από",
    "target_price_required": "Απαιτείται τιμή-στόχος.",
    "target_price_greater_trigger": "Τιμή-στόχος Θα πρέπει να είναι μεγαλύτερη από την τρέχουσα τιμή και",
    "trigger_price": "Τιμή ενεργοποίησης",
    "price_required": "Απαιτείται τιμή.",
    "price_must_be_greater_than": "Η τιμή πρέπει να είναι μεγαλύτερη από",
    "target_price_greater_price_level": "Η τιμή-στόχος πρέπει να είναι μεγαλύτερη από το επίπεδο τιμής",
    "price_must_be_less_than": "Η τιμή πρέπει να είναι μικρότερη από",
    "and_greater_than_zero": "και Μεγαλύτερο από",
    "stop_loss_less_price_level_greater_zero": "Stop loss πρέπει να είναι μικρότερη από το επίπεδο τιμής και μεγαλύτερη από",
    "target_price_less_trigger": "Τιμή-στόχος Θα πρέπει να είναι μικρότερη από την τρέχουσα τιμή και μεγαλύτερη από",
    "sell_stop": "Στάση πώλησης",
    "sell_limit": "Όριο πώλησης",
    "sell_stop_loss_error_message": "Το Stop Loss πρέπει να είναι μεγαλύτερο από την τιμή αγοράς",
    "placed_order_pending_wait": "Η παραγγελία σας εκκρεμεί παρακαλώ περιμένετε",
    "place_other_order": "Τοποθετήστε άλλη παραγγελία",
    "no_account_id_found": "Δεν βρέθηκε αναγνωριστικό λογαριασμού",
    "target_price_must_less_than_trigger_price_greater_zero": "Η τιμή-στόχος πρέπει να είναι μικρότερη από την τιμή ενεργοποίησης και μεγαλύτερη από",
    "sell_stop_loss_greater_trigger_price": "Το Stop Loss πρέπει να είναι μεγαλύτερο από την τιμή ενεργοποίησης",
    "create_new_alert": "Δημιουργία νέας ειδοποίησης",
    "losing": "Απώλεια",
    "winning": "Κερδίζοντας",
    "avg_trade_size": "Μέσο μέγεθος συναλλαγών",
    "asset": "Περιουσιακό στοιχείο",
    "trades_lost": "Χαμένες συναλλαγές",
    "trades_won": "Κερδισμένες συναλλαγές",
    "total_trades": "Σύνολο συναλλαγών",
    "total_trading_volume": "Συνολικός όγκος συναλλαγών",
    "resend": "Επαναποστολή",
    "reset_password_msg": "Ελέγξτε τη διεύθυνση ηλεκτρονικού ταχυδρομείου για οδηγίες επαναφοράς του κωδικού πρόσβασής σας.",
    "server_type": "Τύπος διακομιστή",
    "check_email": "Ελέγξτε το email σας",
    "technicals": "Τεχνικά στοιχεία",
    "disable": "Απενεργοποίηση",
    "amount_greater_100000": "Το ποσό δεν πρέπει να είναι μεγαλύτερο από 100000",
    "x": "X",
    "password_required": "Απαιτείται κωδικός πρόσβασης.",
    "proceed": "Προχωρήστε",
    "turnkey_forex": "TurnkeyForex",
    "coinexx": "Coinexx",
    "finpro_trading": "Finpro Trading",
    "hankotrade": "Hankotrade",
    "brokers": "Μεσίτες",
    "select_broker": "Επιλέξτε έναν μεσίτη",
    "edit_price_alert": "Επεξεργασία ειδοποίησης τιμών",
    "create_price_alert": "Δημιουργία ειδοποίησης τιμών",
    "maximum_100_characters": "Μέγιστο 100 χαρακτήρες",
    "add_comment": "Προσθέστε σχόλιο",
    "price_must_be": "Η τιμή πρέπει να είναι",
    "then": "τότε",
    "crossing_above": "Crossing Above",
    "crossing_below": "Διασχίζοντας το παρακάτω",
    "total_records": "Σύνολο εγγραφών",
    "no_data_found": "Δεν βρέθηκαν δεδομένα",
    "show_more": "Εμφάνιση περισσότερων",
    "show_less": "Εμφάνιση Λιγότερο",
    "at": "στο",
    "trail": "Μονοπάτι",
    "order_pending": "Εκκρεμεί παραγγελία",
    "target_price_less_market_greater_zero": "Η τιμή-στόχος πρέπει να είναι μικρότερη από το εύρος της αγοράς και μεγαλύτερη από",
    "stop_loss_less_market_price_greater_zero": "Το Stop loss πρέπει να είναι μικρότερο από την τρέχουσα τιμή αγοράς και μεγαλύτερο από",
    "stop_loss_greater_market_range": "Το Stop loss πρέπει να είναι μεγαλύτερο από το Market Range",
    "target_price_greater_market_price": "Η τιμή-στόχος πρέπει να είναι μεγαλύτερη από την τρέχουσα τιμή αγοράς",
    "watchlist_create": "Δημιουργία λίστας παρακολούθησης",
    "update": "Ενημέρωση",
    "delete_symbol": "Διαγραφή συμβόλου",
    "are_sure_delete_symbol": "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το Σύμβολο;",
    "symbol_name": "Όνομα συμβόλου",
    "edit_symbol": "Επεξεργασία συμβόλου",
    "enter_watchlist_name": "Εισάγετε όνομα λίστας παρακολούθησης",
    "search_title": "Σύμβολα αναζήτησης",
    "b": "B",
    "s": "S",
    "a": "A",
    "username": "Όνομα χρήστη",
    "email_address": "Διεύθυνση ηλεκτρονικού ταχυδρομείου",
    "old_password_validation": "Απαιτείται παλιός κωδικός πρόσβασης.",
    "old_password_greater_characters": "Ο παλιός κωδικός πρόσβασης δεν μπορεί να είναι μεγαλύτερος από 20 χαρακτήρες",
    "new_password_validation": "Απαιτείται νέος κωδικός πρόσβασης",
    "confirm_password_is_required": "Απαιτείται επιβεβαίωση του κωδικού πρόσβασης.",
    "entered_password_not_match": "Οι εισαγόμενοι κωδικοί πρόσβασης δεν ταιριάζουν. Παρακαλώ δοκιμάστε ξανά",
    "display_high_slash_low_grid_view": "Εμφάνιση High / Low σε προβολή πλέγματος",
    "display_spread_grid_view": "Εμφάνιση εξάπλωσης σε προβολή πλέγματος",
    "select_to_date": "Επιλέξτε Ημερομηνία",
    "select_from_date": "Επιλέξτε ημερομηνία από",
    "select_show_order_slash_position_size_in": "Εμφάνιση παραγγελίας / θέσης Μέγεθος σε",
    "select_history_range": "Επιλέξτε Εύρος ιστορικού",
    "lot_size_greater_than": "Το μέγεθος της παρτίδας δεν πρέπει να είναι μεγαλύτερο από",
    "select_time_zone": "Επιλέξτε Ζώνη ώρας",
    "select_font_size": "Επιλέξτε μέγεθος γραμματοσειράς",
    "select_mode_view_suits": "Επιλέξτε τον τρόπο προβολής που σας ταιριάζει.",
    "selected": "Επιλεγμένα",
    "basic_chart_view": "Βασική προβολή διαγράμματος",
    "grid_view": "Προβολή πλέγματος",
    "multi_chart_view": "Προβολή πολλαπλών διαγραμμάτων",
    "settings_effect_trading_page": "Αυτές οι ρυθμίσεις ισχύουν μόνο στη σελίδα συναλλαγών.",
    "market_watch": "Παρακολούθηση αγοράς",
    "favorite": "Αγαπημένο",
    "one_click_trading": "Συναλλαγές με ένα κλικ",
    "new_watchlist": "Νέα λίστα παρακολούθησης",
    "maximum_5_watchlists": "Μπορείτε να δημιουργήσετε το πολύ 5 λίστες παρακολούθησης.",
    "new_watchlist_successfully": "Νέα λίστα παρακολούθησης έχει προστεθεί με επιτυχία",
    "delete_watchlist": "Διαγραφή λίστας παρακολούθησης",
    "delete_watchlist_successfully": "Η λίστα παρακολούθησης έχει διαγραφεί με επιτυχία",
    "edit_watchlist": "Επεξεργασία λίστας παρακολούθησης",
    "watchlist_updated_successfully": "Η λίστα παρακολούθησης ενημερώθηκε με επιτυχία",
    "go_to_order": "Πηγαίνετε στην παραγγελία",
    "search_filter_fx": "FX",
    "mon": "Δευτέρα",
    "tue": "Τρίτη",
    "wed": "Τετ",
    "thu": "Πέμ",
    "fri": "Παρ",
    "sat": "Sat",
    "sun": "Ήλιος",
    "olivia_deo": "Olivia Deo",
    "risk": "Κίνδυνος",
    "profit": "Κέρδη",
    "copiers": "Φωτοαντιγραφικά",
    "win_rate": "Ποσοστό νίκης",
    "greetings_des": "Χαιρετισμούς, το σύστημά μου που παρουσιάζω εδώ απαιτεί τις ακόλουθες ρυθμίσεις λογαριασμού: 600usd--->0.01Lots Κάνουμε veeeery Λίγες συναλλαγές εδώ ετησίως, μεταξύ 60-200 συναλλαγές, Οι πολύ απαραίτητες συναλλαγές, έτσι ώστε - να κρατήσουμε την αναγωγή μας όσο το δυνατόν χαμηλότερη, λαμβάνοντας τις πολύ απαραίτητες συναλλαγές. -Κατεβαίνουμε πάνω από ένα μέσο όρο 30 pips ανά συναλλαγή. *Επιτρέπουμε σε όλες τις συναλλαγές από αυτό το σύστημα να επιτύχουμε παρόμοια αποτελέσματα. SO αισθανθείτε ευπρόσδεκτοι καθώς αυξάνετε το λογαριασμό σας σταθερά μαζί μας και να είστε πολύ υπομονετικοί.",
    "live_profit": "Ζωντανό κέρδος",
    "overall": "Συνολικά",
    "advanced_seats": "Σύνθετα καθίσματα",
    "trading": "Trading",
    "drawDown": "DrawDown",
    "pips": "κουκιά",
    "include_unrealized_pnl": "Συμπεριλάβετε μη πραγματοποιηθέντα Pnl",
    "closed_trades_only": "Μόνο κλειστές συναλλαγές",
    "trades_volume": "Όγκος συναλλαγών",
    "by_pair": "Με ζεύγος",
    "best_worst": "Best-Worst",
    "ranking": "Κατάταξη",
    "paris": "Παρίσι",
    "trading_news": "Εμπορικές ειδήσεις",
    "prev": "Προηγούμενο",
    "next": "Επόμενο",
    "follow": "Ακολουθήστε το",
    "investment": "Επενδύσεις",
    "open_date_time": "Ανοιχτή ημερομηνία & ώρα",
    "close_date_time": "Ημερομηνία & ώρα κλεισίματος",
    "roll": "Ρολό",
    "total": "Σύνολο",
    "aud_slash_cad": "AUD/CAD",
    "position_list": "Κατάλογος θέσεων",
    "trade_history": "Εμπορική ιστορία",
    "completed": "Ολοκληρωμένο",
    "rejected": "Απορρίφθηκε",
    "pending_closed": "Εκκρεμεί Κλειστό",
    "close_time_date": "Ημερομηνία και ώρα κλεισίματος",
    "status": "Κατάσταση",
    "hedge_position": "Θέση αντιστάθμισης",
    "partial_close": "Μερικό κλείσιμο",
    "stop_loss_less_then": "Το stop loss πρέπει να είναι μικρότερο από",
    "greater_then_zero": "και Μεγαλύτερο στη συνέχεια",
    "trailing_stop_greater_one": "Το Trailing Stop πρέπει να είναι μεγαλύτερο από",
    "greater_then": "Η τιμή-στόχος πρέπει να είναι μεγαλύτερη από",
    "stop_loss_greater_then": "Το Stop loss πρέπει να είναι μεγαλύτερο από",
    "target_price_less_then": "Η τιμή-στόχος πρέπει να είναι μικρότερη από",
    "volume_required": "Απαιτείται όγκος.",
    "volume_less_then": "Ο όγκος πρέπει να είναι μικρότερος από",
    "PNL": "PNL",
    "lot_size_partial": "Το μέγεθος του οικοπέδου είναι μικρότερο από το μερικό κλείσιμο",
    "price_greater_then": "Η τιμή πρέπει να είναι μεγαλύτερη από",
    "stop_loss_less_greater_then_zero": "Το Stop loss πρέπει να είναι μικρότερο από το επίπεδο τιμής και μεγαλύτερο από το 0",
    "trailing_stop_greate_then_zero": "Το Trailing Stop πρέπει να είναι μεγαλύτερο τότε",
    "stop_loss_trigger_price": "Η απώλεια διακοπής πρέπει να είναι μεγαλύτερη από την τιμή ενεργοποίησης",
    "date_range": "Εύρος ημερομηνίας",
    "from": "Από το",
    "to": "Προς",
    "target_price_greater_then_zero": "Η τιμή-στόχος πρέπει να είναι μικρότερη από την τιμή ενεργοποίησης και μεγαλύτερη από την",
    "target_price_market_range_greater_zero": "Η τιμή στόχος πρέπει να είναι μικρότερη από το εύρος της αγοράς και μεγαλύτερη από το",
    "order_list": "Κατάλογος παραγγελιών",
    "close_all_trades": "Κλείστε όλες τις συναλλαγές",
    "instrument_name": "Όνομα οργάνου",
    "trade_logs": "Ημερολόγια εμπορίου",
    "transaction_ID": "Αναγνωριστικό συναλλαγής",
    "add_more_leader": "Προσθέστε περισσότερο Leader",
    "total_Profit": "Συνολικό κέρδος",
    "invested": "Επενδύσεις",
    "market101_guard_enabled": "Market101 Guard Ενεργοποιημένο",
    "excessive_losses": "Ο Leader έχει απενεργοποιηθεί λόγω υπερβολικών απωλειών.",
    "filter": "Φίλτρο",
    "remember_filters": "Θυμηθείτε τα φίλτρα",
    "toggle": "Εναλλαγή",
    "matrix": "Μήτρα",
    "select_all": "Επιλέξτε όλα",
    "term": "Όρος",
    "apply": "Εφαρμογή",
    "clear_all": "Εκκαθάριση όλων",
    "follow_more": "Ακολουθήστε περισσότερα",
    "go_to_dashboard": "Πηγαίνετε στο ταμπλό",
    "are_you_sure_stop_coping": "Είστε σίγουρος ότι θέλετε να σταματήσετε να αντιγράφετε αυτόν τον Δάσκαλο;",
    "invested_amount": "Επενδυμένο ποσό",
    "max": "Max",
    "insufficient_funds": "Ανεπαρκή κεφάλαια στο λογαριασμό.",
    "enter_valid_amount": "Παρακαλώ εισάγετε ένα έγκυρο ποσό.",
    "maximum_amount_allowed": "Το μέγιστο επιτρεπόμενο ποσό είναι έως",
    "available_capital": "Διαθέσιμο κεφάλαιο",
    "copy_open_trades": "Αντιγραφή ανοιχτών συναλλαγών",
    "stop_following": "Σταματήστε να ακολουθείτε",
    "leaders": "Ηγέτες",
    "back_to_manual_trading": "Επιστροφή στο Manual Trading",
    "advanced_stats": "Σύνθετα στατιστικά στοιχεία",
    "view_all": "Προβολή όλων",
    "roi": "ROI",
    "load_more": "Φορτώστε περισσότερα",
    "powered_by": "Powered By",
    "act_trader": "Πράξη Trader"
}


// WEBPACK FOOTER //
// ./src/plugins/lang/languages/el.js